
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {amountUtils} from "../../assets/js/utils";
import Scroller from '../common/scroll/Scroller.vue'
import {DEVICE_RATIO,DOWN_CONFIG, UP_CONFIG} from '../common/scroll/base/js/config.js'
import { log } from 'util';

export default {
directives: {
TransferDom
},
components: {
Group,
Cell,
XTable,CellBox,Flexbox,FlexboxItem, XDialog, Scroller
},
computed:{
scrollElement(){
return this.$refs.scroll
}
},
created () {
this.initPage();
},
methods: {
pullUpHandle(){
this.getInfo((res)=>{
this.scrollElement.PullingUpWord="加载完成";
setTimeout(()=>{
this.scrollElement.finish("PullUp");
this.dataList=this.dataList.concat(res.data.data.rows);
this.curYear = null;
},1000)
})
},
initPage(){
this.dataList=[];
this.page=1;
this.getInfo((res)=>{
this.dataList=res.data.data.rows;
})
},
getInfo(callback){
let shopId = this.shopId
let uri = '/v1/shop/'+ shopId+"/bill/GET_SHOP_BILL_LIST";
let params = {
"shopId":shopId,
"billType":2, //团购账单
"currentPage":this.page,
"pageSize":this.pageSize
};
let _this = this;
_this.axios.post(uri, params, {
headers: {}
}).then(function (response) {
if (response.data.code != undefined && response.data.code == 0) {
_this.basicInfo = response.data.data.basicInfo;
callback&&callback(response);
_this.page++;
} else{
_this.showHideOnBlur = true;
_this.dialogMsg = response.data.msg;
}
}).catch(function (response) {
_this.showHideOnBlur = true;
_this.dialogMsg = response.message;
});
},

isNewYear(date){
let dateObj = new Date(date);
if(dateObj.getFullYear()!=this.curYear){
this.curYear = dateObj.getFullYear();
return true;
}
return false;
},
getYear(date){
return new Date(date).getFullYear().toString();
},
getMonth(date){
let dateObj = new Date(date);
let result = dateObj.getMonth()+1;
return result<10?"0"+result:result;
},
getDay(date){
let dateObj = new Date(date);
let result = dateObj.getDate();
return result<10?"0"+result:result;
},
getReportDate(date){
return this.getMonth(date)+"-"+this.getDay(date);
},
getStatusTxt(status){
switch (status){
case 0:
return "未出账";
case 1:
return "未确认";
case 2:
return "已确认";
case 3:
return "发起付款";
case 4:
return "付款成功";
default: return "未知状态";
}
},
getLink(status, billNo){
if(status == 1 || status == 2 || status == 3 || status == 4){
return this.baseUri+"/detail/"+billNo;
}else{
return this.baseUri+"/due";
}
},
transform: amountUtils.transform
},
data () {
let shopId = this.$route.params.shopId;
let baseUri = "/shop/"+shopId+"/tuanFinancial";
return {
dialogMsg: '',
showHideOnBlur:false,
shopId,
baseUri,
basicInfo: {},
dataList: [],
page:1,
pageSize:15,
pulldown: true,
DEVICE_RATIO,
DOWN_CONFIG,
UP_CONFIG
}
}
}



// WEBPACK FOOTER //
// ./src/components/tuan_financial/Report.vue